import ActOnSettlementPage from '@/components/features/ActOnSettlement/ActOnSettlementPage';
import type { PagesLayoutAnalyticsData } from '@/layouts/PagesLayout';

interface ActOnSettlementProps {
  analytics: PagesLayoutAnalyticsData;
}
export default function ActOnSettlement({ analytics }: ActOnSettlementProps) {
  return <ActOnSettlementPage analytics={analytics} />;
}
